import { useEffect, useState } from "react";

export function useDissidia(name, timeout = 5000) {
  const [Component, setComponent] = useState(null);

  useEffect(() => {
    if (typeof window === "undefined") return;

    let found = false;

    const interval = setInterval(() => {
      const ui = window.DissidiaUi || window.DissidiaUI;

      if (ui && ui[name]) {
        setComponent(() => ui[name]);
        found = true;
        clearInterval(interval);
      }
    }, 200);

    const timer = setTimeout(() => {
      if (!found) {
        console.warn(
          `❌ Dissidia "${name}" not found after ${timeout}ms`
        );
      }
      clearInterval(interval);
    }, timeout);

    return () => {
      clearInterval(interval);
      clearTimeout(timer);
    };
  }, [name, timeout]);

  return Component;
}